module.exports = __webpack_public_path__ + "img/31.86264c46.jpg";